import intlTelInputComponent from "intl-tel-input";
import utils from "intl-tel-input/build/js/utils";

import "intl-tel-input/build/css/intlTelInput.css";
import "./phone-number.component.scss";

export default {
  template: require('./phone-number.component.html'),
  require: {
    form: '^form'
  },
  bindings: {
    number: '<vuiPnNumber',
    onChange: '&vuiPnOnChange',
    isRequired: "@vuiPnIsRequired",
    showIcon: "@vuiPnShowIcon",
    disabled: '<?vuiDisabled'
  },
  controller: function ($element, $http, $scope, $timeout, $t) {

    'ngInject';

    const self = this;
    let iti;
    const countries = [
      'at', 'au', 'be', 'br', 'ca',
      'ch', 'de', 'dk', 'ee', 'es',
      'fi', 'fr', 'gb', 'gr', 'ie',
      'it', 'lt', 'lu', 'lv', 'my',
      'mx', 'nl', 'no', 'nz', 'pl',
      'pt', 'se', 'si', 'sk', 'us'
    ];

    self.$onInit = () => {
      self.icon = self.showIcon !== 'false'

      $timeout(() => {
        iti = initializeComponent();

        if (self.number) {
          iti.setNumber(self.number);
        }
      });
    };

    const onSubmit = () => {
      self.onChange({phone: self.number, isValid: iti.isValidNumber()});
    };

    const initializeComponent = () => {
      const input = $element.children()[0].children[0];
      const ipInfoToken = process.env.IP_INFO_TOKEN;

      const iti = intlTelInputComponent(input, {
        utilsScript: utils,
        autoHideDialCode: true,
        nationalMode: false,
        autoPlaceholder: "aggressive",
        initialCountry: "auto",
        formatOnDisplay: true,
        customContainer: 'vui-phone-number__container',
        geoIpLookup: (callback) => {
          $http.get("https://ipinfo.io?token=" + ipInfoToken, () => {}, "jsonp")
            .then(resp => {
              const countryCode = (resp && resp.data && resp.data.country) ? resp.data.country : "us";
              if (countryCode && countries.indexOf(countryCode.toLowerCase()) >= 0) {
                callback(countryCode);
              } else {
                callback('us');
              }
            }, () => callback('us'));
        },
        hiddenInput: "fullNumber",
        onlyCountries: countries,
        placeholderNumberType: "MOBILE",
        preferredCountries: ['us', 'ca'],
        separateDialCode: true
      });

      const errorMsg = document.querySelector("#vui-number-error-msg");

      const errorMap = [
        $t('shared.phone_number.invalid_number_error'),
        $t('shared.phone_number.invalid_country_code_error'),
        $t('shared.phone_number.number_too_short_error'),
        $t('shared.phone_number.number_too_long_error'),
        $t('shared.phone_number.invalid_number_error')
      ];

      const reset = () => {
        input.classList.remove("vui-phone-number__error");
        errorMsg.innerHTML = "";
        self.number = iti.getNumber();
        onSubmit();
      };

      const validate = () => {
        if (input.value.trim() && !iti.isValidNumber()) {
          input.classList.add("vui-phone-number__error");
          let errorCode = iti.getValidationError();
          errorMsg.innerHTML = errorMap[errorCode] || errorMap[4];
          errorMsg.classList.remove("hide");
        } else if (self.isRequired === 'true' && !input.value.trim()) {
          input.classList.add("vui-phone-number__error");
          errorMsg.innerHTML = $t('shared.phone_number.required_error');
          errorMsg.classList.remove("hide");
        }
      };

      input.addEventListener('blur', () => {
        reset();
        validate();
      });

      input.addEventListener('change', reset);
      input.addEventListener('keyup', reset);

      $scope.$watch('$ctrl.form.$submitted', (newValue, oldValue) => {
        if (newValue) {
          validate();
        }
      });

      return iti;
    }
  }
};
